import { lockScroll } from '@/utils/utils';

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bindShow: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    bindShow: {
      immediate: true,
      handler: lockScroll
    }
  }
};
